const BaseUrl = {
  base_url: `http://localhost:3000`,
  // api_url: `http://44.195.125.80:10067/travel-guide/api/v1`,
  // api_url:`http://localhost:10067/travel-guide/api/v1`
   api_url:`https://walkapp.glam-atl.com/travel-guide/api/v1`
};
export default BaseUrl;

// http://44.195.125.80:10067/travel-guide/api/v1
  